import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import ReCAPTCHA from "react-google-recaptcha";

export class Forms extends Component {
    
    constructor(props) {
        super(props);
        
        let { jobID, teamID } = props

        this.state = {
          location: this.props.location.pathname.replace("/", ""),
          form: {},
          success: false,
          file: {filename: "Upload your resume..."},
          goBack: this.props.history.goBack,
          ReCap: 0
        };

        if(jobID && teamID) {

            this.state.form[8] = jobID
            this.state.form[9] = teamID

        }


        // console.log("JobID", jobID)
        // console.log("Team", teamID)
    
    }

    handleChange = (e) => 
    {
        //let name = e.target.name
        let newState = this.state
        let id = e.target.dataset.id

        newState.form[id] = e.target.value
        
        if(id === '7') {
            document.querySelector(".file").classList.toggle("is-success");
            newState.file.filename = (e.target.value) ? e.target.value.split("\\")[2] : "Upload your resume...";
        }

        this.setState(newState)
    }

    handleRecaptcha = (e) => 
    {
        let newState = this.state
        
        if(e.length !== 0) {
            newState.ReCap = e;
        } else {   
            newState.ReCap = 0;
        }

        this.setState(newState)
        
    }

    handleSubmit = (e) => {

        e.preventDefault();

        let garry = document.getElementsByClassName("fieldset")
        let submit = document.getElementsByClassName("submit")
        garry[0].setAttribute("disabled", true)
        submit[0].classList.add("is-loading")

        //const recaptchaValue = props.grecaptcha.getResponse();
        let re = this.state.ReCap

        if(re === 0) {
            let rewarn = document.querySelector("#reWarn");
            rewarn.classList.remove("is-hidden");
            garry[0].disabled = false
            submit[0].classList.remove("is-loading")
            return false;
        }
        
        let form = this.state.form
        let form_id = document.querySelector(`input[name="form_id"]`).value
        let fileField = (document.querySelector('input[type="file"]')) ? document.querySelector('input[type="file"]') : false;
        let state = (document.querySelector(`select[name="state"]`)) ? document.querySelector(`select[name="state"]`).value : false;
        let stateId =(document.querySelector(`select[name="state"]`)) ? document.querySelector(`select[name="state"]`).dataset.id : false;
        
        const formData = new FormData();

        formData.append('form_id', form_id);

        if(fileField && fileField.files.length > 0) {

            let types = [
                "application/pdf",
                "text/plain",
                "application/vnd.oasis.opendocument.text",
                "application/rtf",
                "application/vnd.ms-powerpoint",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "application/msword",
                "application/vnd.ms-xpsdocument"
            ]


            let name = fileField.files[0].name.split('.').pop()

            name = (name === "docx" || name === "doc") ? true : false;

            //console.log("file", fileField.files[0])
            console.log("type", fileField.files[0].type)

            if(types.includes(fileField.files[0].type) || name) {
                formData.append('resume', fileField.files[0]);
            } else {
                document.querySelector("#docWarn").classList.remove("is-hidden");
                garry[0].disabled = false
                submit[0].classList.remove("is-loading")
                return false;
            }
            
        }
        
        if(state) {
            formData.append(stateId, state)
        }

        

        Object.keys(form).forEach(function (item) {
            let id = item.toString()
            if(id !== "7") {
                formData.append(id, form[item])
                console.log("data", id, form[item])
            }
        });

        //console.log(formData)

        async function postData(url = '', data = {}) {
            // Default options are marked with *
            const response = await fetch(url, {
              method: 'POST', // *GET, POST, PUT, DELETE, etc.
              mode: 'cors',
              body: data // body data type must match "Content-Type" header
            })
            return await response; // parses JSON response into native JavaScript objects
          }

          let url = (window.location.host === "localhost:3000") ? "http://localhost/wpdivi/wp-json/rictest/v1/postit" : "https://beta.riccione.com/wp-json/ricapi/v1/postit"

          postData(url, formData)
          .then((data) => {
            if(data.ok) {
                //console.log(data)
                this.setState({success: true})
            }
          })
          .catch(error => console.log('error', error))

    }

    Form = () => {

        const searchRegExp = /\//g;
        const path = this.props.location.pathname.replace(searchRegExp, "")

        let fid = "3";
        let extraFields = (<></>)
        let cityid, stateid
        let name = (

            <div className="field is-horizontal">
                <div className="field-body">
                    <div className="field">
                        <label className="label  ">First Name</label>
                        <div className="control">
                            <input className="input" type="text" placeholder="First Name" name="name_a" data-id="1.3" value={this.state.form.name} onChange={this.handleChange} required/>
                        </div>
                    </div>
                    <div className="field">
                        <label className="label  ">Last Name</label>
                        <div className="control">
                            <input className="input" type="text" placeholder="Last Name" name="name_b" data-id="1.6" value={this.state.form.name} onChange={this.handleChange} required/>
                        </div>
                    </div>
                </div>
            </div>
                    
        )

        if(path === "contact-us") {

            name = (
                    <div className="field">
                        <label className="label  ">Name</label>
                        <div className="control">
                            <input className="input" type="text" placeholder="Your Name" name="name" data-id="1" value={this.state.form.name} onChange={this.handleChange} required/>
                        </div>
                    </div>
            )

        }

        

        if(path !== "contact-us") { 

            if(this.props.location.search.length > 0) {
                fid = "2"
                cityid = "11"
                stateid = "10"

            } else if(this.props.location.search.length === 0){
                fid = "1"
                cityid = "9"
                stateid = "8"
                extraFields = (

                    <>
                    <div className="field">
                        <label className="label  ">Desired Job Title or Role</label>
                        <div className="control">
                            <textarea className="textarea" placeholder="Your Message" name="desiredjob" data-id="5" value={this.state.form.desiredjob} onChange={this.handleChange} required/>
                        </div>
                    </div>

                    <div className="field">
                    <label className="label  ">Comments</label>
                        <div className="control">
                            <textarea className="textarea" placeholder="Your Message" name="jobdetails" data-id="6" value={this.state.form.jobdetails} onChange={this.handleChange} required/>
                        </div>
                    </div>
                    </>

                )
            }
        }

        let Contact = (

            <fieldset className="fieldset">
                <form className="section" onSubmit={this.handleSubmit} encType="multipart/form-data">
                    {name}

                    <div className="field">
                        <label className="label  ">Email</label>
                        <div className="control">
                            <input className="input" type="email" placeholder="Your Email" name="email" data-id="3" value={this.state.form.email} onChange={this.handleChange} required/>
                        </div>
                    </div>

                    <div className="field">
                    <label className="label  ">Message</label>
                        <div className="control">
                            <textarea className="textarea" placeholder="Your Message" name="message" data-id="2" value={this.state.form.message} onChange={this.handleChange} required/>
                        </div>
                    </div>

                    <div className="field">
                        <label className="label  ">Phone Number</label>
                        <div className="control">
                            <input className="input" type="tel" pattern="[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*" placeholder="100-200-3000" data-id="4" name="phone" value={this.state.form.phone} onChange={this.handleChange} />
                        </div>
                    </div>

                    <span id="reWarn" className="tag is-danger is-hidden">Please check the box below!</span>
                    <div className="field">
                        <ReCAPTCHA 
                            sitekey="6LfvpyIUAAAAAFEba2QhbCiYCMF7iCy3PfpdBF0j"
                            onChange={this.handleRecaptcha}
                        />
                    </div>

                    <div className="field is-grouped">
                        <div className="control">
                                <button className="button is-link submit">Submit</button>
                        </div>
                        <div className="control">
                            <button className="button" onClick={this.state.goBack}>Cancel</button>
                        </div>
                    </div>
                    <input type="hidden" name="form_id" value={fid} />
                </form>
            </fieldset>

        )

        let Apply = (

            <fieldset className="fieldset">
                <form onSubmit={this.handleSubmit}  encType="multipart/form-data" >
                    <div className="field is-horizontal">
                        <div className="field-body">
                            <div className="field">
                                <label className="label  ">First Name</label>
                                <div className="control">
                                    <input className="input" type="text" placeholder="First Name" data-id="1.3" name="name_a" value={this.state.form.name} onChange={this.handleChange} required/>
                                </div>
                            </div>
                            <div className="field">
                                <label className="label  ">Last Name</label>
                                <div className="control">
                                    <input className="input" type="text" placeholder="Last Name" data-id="1.6" name="name_b" value={this.state.form.name} onChange={this.handleChange} required/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="field">
                        <label className="label  ">Email</label>
                        <div className="control">
                            <input className="input" type="email" placeholder="Email input" name="b" data-id="2" value={this.state.form.b} onChange={this.handleChange} required/>
                        </div>
                    </div>

                    <div className="field">
                        <label className="label  ">Phone</label>
                        <div className="control">
                            <input className="input" type="tel" pattern="[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*" placeholder="100-200-3000" data-id="3" name="phone" value={this.state.form.phone} onChange={this.handleChange} />
                        </div>
                    </div>

                    <div className="field">
                        <label className="label  ">City</label>
                        <div className="control">
                            <input className="input" type="text" placeholder="Text input" name="city" data-id={cityid} value={this.state.form.city} onChange={this.handleChange} />
                        </div>
                    </div>

                    <div className="field">
                        <label className="label  ">State</label>
                        <div className="control">
                            <div className="select">
                                <select name="state" defaultValue="Texas" data-id={stateid} >
                                <option>Select dropdown</option>
                                
                                <option value="Alabama">Alabama</option><option value="Alaska">Alaska</option><option value="Arizona">Arizona</option><option value="Arkansas">Arkansas</option><option value="California">California</option><option value="Colorado">Colorado</option><option value="Connecticut">Connecticut</option><option value="Delaware">Delaware</option><option value="District of Columbia">District of Columbia</option><option value="Florida">Florida</option><option value="Georgia">Georgia</option><option value="Hawaii">Hawaii</option><option value="Idaho">Idaho</option><option value="Illinois">Illinois</option><option value="Indiana">Indiana</option><option value="Iowa">Iowa</option><option value="Kansas">Kansas</option><option value="Kentucky">Kentucky</option><option value="Louisiana">Louisiana</option><option value="Maine">Maine</option><option value="Maryland">Maryland</option><option value="Massachusetts">Massachusetts</option><option value="Michigan">Michigan</option><option value="Minnesota">Minnesota</option><option value="Mississippi">Mississippi</option><option value="Missouri">Missouri</option><option value="Montana">Montana</option><option value="Nebraska">Nebraska</option><option value="Nevada">Nevada</option><option value="New Hampshire">New Hampshire</option><option value="New Jersey">New Jersey</option><option value="New Mexico">New Mexico</option><option value="New York">New York</option><option value="North Carolina">North Carolina</option><option value="North Dakota">North Dakota</option><option value="Ohio">Ohio</option><option value="Oklahoma">Oklahoma</option><option value="Oregon">Oregon</option><option value="Pennsylvania">Pennsylvania</option><option value="Rhode Island">Rhode Island</option><option value="South Carolina">South Carolina</option><option value="South Dakota">South Dakota</option><option value="Tennessee">Tennessee</option><option value="Texas">Texas</option><option value="Utah">Utah</option><option value="Vermont">Vermont</option><option value="Virginia">Virginia</option><option value="Washington">Washington</option><option value="West Virginia">West Virginia</option><option value="Wisconsin">Wisconsin</option><option value="Wyoming">Wyoming</option><option value="Armed Forces Americas">Armed Forces Americas</option><option value="Armed Forces Europe">Armed Forces Europe</option><option value="Armed Forces Pacific">Armed Forces Pacific</option>

                                </select>
                            </div>
                        </div>
                    </div>

                    {extraFields}
                    <span id="docWarn" className="tag is-danger is-hidden">Please Upload a valid document or PDF file</span>
                    <div className="file">
                        <label className="file-label">
                            <input className="file-input" type="file" data-id="7" name="resume" required onChange={this.handleChange} />
                            <span className="file-cta">
                            <span className="file-icon">
                                <i className="fas fa-upload"></i>
                            </span>
                            <span className="file-label">
                                {this.state.file.filename} 
                            </span>
                            </span>
                        </label>
                    </div>
                    <br />
                    <span id="reWarn" className="tag is-danger is-hidden">Please check the box below!</span>
                    <div className="field">
                        <ReCAPTCHA 
                            sitekey="6LfvpyIUAAAAAFEba2QhbCiYCMF7iCy3PfpdBF0j"
                            onChange={this.handleRecaptcha}
                        />
                    </div>
                    <br />

                    <div className="field is-grouped">
                        <div className="control">
                            <button className="button is-link submit">Submit</button>
                        </div>
                        <div className="control">
                            <button className="button" onClick={this.state.goBack}>Cancel</button>
                        </div>
                    </div>
                    <input type="hidden" name="form_id" value={fid} />
                    
                </form>
            </fieldset>

        )


        let r = (path === "contact-us") ? Contact : Apply

        return r

    }

    render() {

        const check = this.state.success
        const searchRegExp = /\//g;
        const path = this.state.location.replace(searchRegExp, "")

        let rto = (path === "contact-us") ? "/thanks" : "/thank-you"

        return (
            <React.Fragment>
            {check ? (
                <Redirect to={rto} />
              ) : (
                <this.Form />
            )}
            </React.Fragment>
        )
    }
}